import React from 'react';
import CloseModal from './CloseModal';
import { CancelIcon, EditIcon, SaveIcon } from './IconButtons';
import Dropdown from './Dropdown';
import InputField from './InputField';
import CountryCodeDropdown from './CountryCodeDropdown';
import { countryPhoneCode } from '../Constants/constant';

const InterviewScheduleModal = ({data, OnlyView, companyList, positionList, errors, loading, disabled, onChange, onClose, onEdit, onCancel, onSubmit }) => {
    const interviewMode = [
        {value: "In Person", label: "In Person"},
        {value: "Virtual", label: "Virtual"},
        {value: "Teliphonic", label: "Teliphonic"},
    ]
    return (
        <div className=' w-full h-screen fixed left-0 top-0 z-20 flex items-center justify-center blurBack'>
            <div onClick={(e) => { e.stopPropagation(); }} className='relative w-[70vw] bg-white overflow-auto mx-10 mb-5 py-5 px-8 rounded-2xl '>
                {!OnlyView && 
                (onEdit && disabled ? 
                    <EditIcon disabled={loading} className=" top-3 left-8" onClick={onEdit} /> :
                    <>
                    <CancelIcon disabled={loading} className=" top-3 left-8" onClick={onCancel} />
                    <SaveIcon btnName="Submit" disabled={loading} loading={loading} className=" top-3 left-36" onClick={onSubmit} />
                </>)
                }
                <CloseModal disabled={loading} onClick={onClose} />
                <h1 className='text-center text-xl font-semibold py-2 text-blue-950'>Candidate Interview Schedule</h1>
                <form className='text-left flex flex-col gap-x-4 gap-y-3 px-2 max-h-[70vh] overflow-y-scroll'>
                    <InputField
                    id="interview_round"
                    name="interview_round"
                    label="Interview Round:"
                    type="text"
                    disabled={true}
                    placeholder="Interview Round"
                    textColor={disabled && "text-blue-700"}
                    value={data?.interview_round}
                    error={errors?.interview_round}
                    />
                    <div className='grid grid-cols-2 gap-3'>
                        <InputField
                        id="candidate"
                        name="candidate"
                        label="Candidate Name:"
                        type="text"
                        disabled={true}
                        placeholder="Candidate Name"
                        textColor={disabled && "text-blue-700"}
                        value={data?.candidate}
                        error={errors?.candidate}
                        />
                        <InputField
                        id="candidate_email"
                        name="candidate_email"
                        label="Candidate Email:"
                        type="text"
                        disabled={true}
                        placeholder="Candidate Email"
                        textColor={disabled && "text-blue-700"}
                        value={data?.candidate_email}
                        error={errors?.candidate_email}
                        />
                        <InputField  
                        id="interview_date" 
                        name="interview_date" 
                        label="Interview Date:"
                        type="date" 
                        disabled={disabled}
                        textColor={disabled && "text-blue-700"}
                        value={data?.interview_date}
                        error={errors?.interview_date}
                        onChange={onChange}
                        required={true}
                        />
                        <InputField  
                        id="interview_time" 
                        name="interview_time" 
                        label="Interview Time:"
                        type="time" 
                        disabled={disabled}
                        textColor={disabled && "text-blue-700"}
                        value={data?.interview_time}
                        error={errors?.interview_time}
                        onChange={onChange}
                        required={true}
                        />
                        <Dropdown 
                        id="interview_mode" 
                        name="interview_mode"
                        label="Interview Mode:"
                        onChange={onChange}
                        className=" rounded border border-gray-300 w-full text-[0.8rem]"
                        disabled={disabled}
                        placeholder={`Select`}
                        textColor={disabled && "text-blue-700"}
                        value={data?.interview_mode}
                        error={errors?.interview_mode}
                        options={interviewMode}
                        required={true}
                        />
                        <InputField
                        id="interview_location"
                        name="interview_location"
                        label="Interview Location:"
                        type="text"
                        disabled={disabled}
                        placeholder="Interview Location"
                        textColor={disabled && "text-blue-700"}
                        value={data?.interview_location}
                        error={errors?.interview_location}
                        onChange={onChange}
                        required={true}
                        />
                        <InputField
                        id="contact_person_name"
                        name="contact_person_name"
                        label="Contact Person Name:"
                        type="text"
                        disabled={disabled}
                        placeholder="Contact Person Name"
                        textColor={disabled && "text-blue-700"}
                        value={data?.contact_person_name}
                        error={errors?.contact_person_name}
                        onChange={onChange}
                        required={true}
                        />
                        <div>
                            <h2 className='flex text-left font-medium text-gray-700 mb-1'>Contact Number:</h2>
                            <div className="flex items-start gap-2">
                                <CountryCodeDropdown 
                                    id="phone_code" 
                                    name="phone_code"
                                    onChange={onChange}
                                    className=" rounded border border-gray-300 w-full text-[0.8rem]"
                                    disabled={disabled}
                                    placeholder={`Country Code`}
                                    textColor={disabled && "text-blue-700"}
                                    value={data?.phone_code}
                                    error={errors?.phone_code}
                                    options={countryPhoneCode}
                                />
                                <InputField
                                    id="contact_person_mobile_number"
                                    name="contact_person_mobile_number"
                                    type="text"
                                    disabled={disabled}
                                    placeholder={`Contact Person Number`}
                                    textColor={disabled && "text-blue-700"}
                                    className="flex-1"
                                    value={data?.contact_person_mobile_number}
                                    error={errors?.contact_person_mobile_number}
                                    onChange={onChange}
                                />
                                
                            </div>
                        </div>
                    </div>
                    <div>
                        <h2 className='block text-left font-medium text-gray-700 mb-1'>Remarks</h2>
                        <textarea name="interview_remarks" id="interview_remarks" rows="5"
                        className='w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                        disabled={disabled} placeholder="Enter Remark..." onChange={onChange}
                        >{data?.interview_remarks}
                        </textarea>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default InterviewScheduleModal;
